import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {VueAxios} from './utils/request'

import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import './assets/res/layui/css/layui.css'
import './assets/res/css/global.css'

Vue.use(VueAxios)
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
